import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  createProgramCurrency,
  deleteProgramCurrency,
} from '@store/membership/ProgramCurrencyReducer'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'

export const ProgramCurrencyForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const dispatch = useAppDispatch()
    const { error } = useAppSelector((state) => state.programCurrency)

    return (
      <SBRM.BaseEntityForm
        {...{ ref, formProps }}
        error={error && String(error)}
        formActions={{
          create: Create,
          delete: Delete,
        }}
        handlers={{
          create: async (values) => {
            return dispatch(createProgramCurrency(values)).then(() => {
              return true
            })
          },
          delete: async (values) => {
            return dispatch(deleteProgramCurrency(values)).then(() => {
              return true
            })
          },
        }}
      />
    )
  }
)

ProgramCurrencyForm.displayName = 'ProgramCurrencyForm'

export default ProgramCurrencyForm
